// Import SDK
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth"; // ✅ Tambahkan ini

// Config kamu di sini
const firebaseConfig = {
  apiKey: "AIzaSyBbf71lr2QbJ-qqgQc2J5Ttdctp6Yv6_iw",
  authDomain: "wbgkn-4cced.firebaseapp.com",
  projectId: "wbgkn-4cced",
  storageBucket: "wbgkn-4cced.firebasestorage.app",
  messagingSenderId: "128256622715",
  appId: "1:128256622715:web:ae63a9bd2b59170e8be2de",
  measurementId: "G-VPJVGK6XT1",
};

// Init
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
export const auth = getAuth(app);
